/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

export enum BEAMS_NETWORK_GROUP_IDS {
  Ka = 'ka',
  Ku = 'ku',
  HCX = 'hcx',
  VS3 = 'vs3',
  GX = 'gx',
}

export const DEFAULT_NETWORK_GROUP_ID = 'ku';

export const DISABLED_OPACITY = 0.38;
export const ENABLED_OPACITY = 1;
